import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  token: null,
  user: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      let user = action.payload.user;
      // Construct full avatar URL if avatar exists
      if (user.avatar) {
        const orgNum = user.department.costCenter.organization.orgNum;
        const adminBaseUrl = 'https://timesheet-admin.oseelight.com';
        const fullAvatarUrl = `${adminBaseUrl}/upload/${orgNum}/avatar/${user.avatar}`;
        user.avatar = fullAvatarUrl;
      }
      state.user = user;
      state.roleName = action.payload.user.roles.roleName;
      state.loading = false;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
      state.loading = false;
      state.error = null;
    },
    updateUser: (state, action) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout, updateUser } = authSlice.actions;
export default authSlice.reducer;
